import request from 'local_modules/request'
import { constants, modals, convertPrice } from 'helpers'
import { reducers, getState } from 'redux/core'
import actions from 'redux/actions'


const setFetching = (isFetching) => reducers.marketplace.adminTariffPage.setFetching(isFetching)

const fetchCategories = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.tariffCategory + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminTariffPage.setCategories(data))
    .catch((error) => console.log(error))
}

const fetchTimes = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.tariffTime + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminTariffPage.setTimes(data))
    .catch((error) => console.log(error))
}

const fetchTariffs = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.tariff + `/${tool}?all=true`)
    .then(({ data }) => data)
    .then((data) => {
      let tariffs = convertPrice.toRub(data || [])
      tariffs     = convertPrice.toRub(tariffs, 'discountPrice')

      console.log(tariffs)
      reducers.marketplace.adminTariffPage.setTariffs(tariffs)
    })
    .catch((error) => console.log(error))
}

const setCategories = (categories) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(constants.marketplace.tariffCategory + `/${tool}`, categories)
    .then(({ data }) => data)
    .catch((error) => {
      actions.modals.open(modals.Dialog, {
        title: 'Ошибка',
        text: JSON.stringify({ error })
      })
      console.log(error)
    })
}

const setTimes = (times) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(constants.marketplace.tariffTime + `/${tool}`, times)
    .then(({ data }) => data)
    .catch((error) => {
      actions.modals.open(modals.Dialog, {
        title: 'Ошибка',
        text: JSON.stringify({ error })
      })
      console.log(error)
    })
}

const setTariffs = (tariffs) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  let newTariffs  = convertPrice.fromRub(tariffs)
  newTariffs      = convertPrice.fromRub(newTariffs, 'discountPrice')

  return request.post(constants.marketplace.tariff + `/${tool}`, newTariffs)
    .then(({ data }) => data)
    .then((data) => console.log(data))
    .catch((error) => {
      actions.modals.open(modals.Dialog, {
        title: 'Ошибка',
        text: JSON.stringify({ error })
      })
      console.log(error)
    })
}


export default {
  setFetching,

  fetchCategories,
  fetchTariffs,
  fetchTimes,

  setCategories,
  setTariffs,
  setTimes,
}
